export enum EquipmentElements {
	BaseRectangle = 'RectangleBase',
	BaseTrapeze = 'TrapezeBase',
	BackWall = 'BackWall',
	CentralPillar  = 'CentralPillar',
	HookWall = 'HookWall',
	PerforatedWall = 'PerforationWall',
	SideWalls = 'SidesWall',
	Showcase = 'Showcase',
	HookPanel = 'HookPanel',
	Perforation = 'Perforation',
	Shelf = 'Shelf',
	AngleShelf = 'AngleShelf',
	HangBar = 'HangBar',
	Hook = 'Hook',
	Hole = 'Hole',
	Box = 'Box',
	SlicedBox = 'SlicedBox',
	Partition = 'Partition'
}